import _indexOf from 'lodash/indexOf'

import { CELL_SELECT_COLORS } from '~shared/consts'
import { EMPTY_ARRAY } from '~shared/core/primitives'
import { ColumnType } from '~shared/rundown/column'
import { getContentForSelectCell } from '~shared/types/Cell'

import { useCellSnapshot } from '@/features/rundown/data/cells.store'

import { useCellColumn } from '../../cell.hooks'

import {
  SelectColumnCellButton,
  SelectColumnCellContentWrapper,
} from './SelectColumnCell.shared'

/**
 * Renders non-editable and non-interactive Cell content in a Column of type
 * `select`, specifically for the Rundown Output List.
 */
export function SelectColumnCellOutput() {
  const cell = useCellSnapshot()
  const column = useCellColumn()

  // Assert component is used in Column of type `select`.
  if (column.type !== ColumnType.SELECT) {
    throw new Error('Invalid column data')
  }

  const selectOptions = column.options || EMPTY_ARRAY

  const selectedValue = getContentForSelectCell(cell?.content)

  const selectedValueColor =
    CELL_SELECT_COLORS[_indexOf(selectOptions, selectedValue)]

  const isValidSelection = Boolean(
    selectedValue && selectOptions.includes(selectedValue),
  )

  return (
    // <CellFrame> // Not wrapped in CellFrame in Output
    <SelectColumnCellContentWrapper>
      <SelectColumnCellButton
        selectedValue={isValidSelection ? selectedValue : '-'}
        selectedValueColor={selectedValueColor}
        disabled={true}
      />
    </SelectColumnCellContentWrapper>
    // </CellFrame>
  )
}
